import { useListSectionsQuery } from '@/services/api/demandExampleTemplateService';

interface TemplateViewProps {
  demandExampleId: string;
  templateId: string;
}

export const TemplateView = ({
  demandExampleId,
  templateId,
}: TemplateViewProps) => {
  const {
    data: sections,
    isFetching,
    error,
  } = useListSectionsQuery({ demandExampleId, templateId });

  if (isFetching) {
    return (
      <div className="flex justify-center p-8 text-sm text-muted-foreground">
        Loading sections…
      </div>
    );
  }

  if (error) {
    return <p className="text-red-500 text-sm p-4">Failed to load sections.</p>;
  }

  if (!sections?.length) {
    return (
      <p className="text-sm text-muted-foreground p-4">No sections yet.</p>
    );
  }

  return (
    <div className="overflow-auto p-6 max-w-4xl mx-auto space-y-10">
      {sections.map((sec) => (
        <section key={sec.id} className="flex flex-col gap-4">
          <header>
            <h3 className="text-lg font-semibold break-words">
              {sec.section_name || 'Untitled Section'}
            </h3>
            {sec.description && (
              <p className="text-sm text-muted-foreground whitespace-pre-wrap">
                {sec.description}
              </p>
            )}
            {sec.order !== undefined && (
              <p className="text-xs text-muted-foreground">
                Order: {sec.order}
              </p>
            )}
          </header>

          {sec.image_url ? (
            <img
              src={sec.image_url}
              alt={sec.section_name}
              className="w-full h-auto rounded border"
            />
          ) : (
            <div className="w-full aspect-video bg-zinc-100 flex items-center justify-center text-xs text-zinc-500 rounded border">
              No image available
            </div>
          )}
        </section>
      ))}
    </div>
  );
};
